import AppDispatcher, { type AppAction } from '../AppDispatcher';

const CHANGE_EVENT = 'change';

// Lightweight event emitter to avoid depending on Node polyfills in the browser bundle.
class SimpleEventEmitter {
   listeners: Record<string, Set<(...args: unknown[]) => void>> = {};

   on(event: string, callback: (...args: unknown[]) => void) {
      if (!this.listeners[event]) {
         this.listeners[event] = new Set();
      }
      this.listeners[event].add(callback);
   }

   removeListener(event: string, callback: (...args: unknown[]) => void) {
      if (this.listeners[event]) {
         this.listeners[event].delete(callback);
      }
   }

   emit(event: string, ...args: unknown[]) {
      if (this.listeners[event]) {
         this.listeners[event].forEach((listener) => listener(...args));
      }
   }
}

class BaseStore extends SimpleEventEmitter {
   dispatchToken: string | null = null;

   emitChange() {
      this.emit(CHANGE_EVENT);
   }

   addChangeListener(callback: () => void) {
      this.on(CHANGE_EVENT, callback);
   }

   removeChangeListener(callback: () => void) {
      this.removeListener(CHANGE_EVENT, callback);
   }

   register(callback: (action: AppAction) => void) {
      this.dispatchToken = AppDispatcher.register(callback);
   }
}

export default BaseStore;
